import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "order-report-manage" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "summary-bar" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "pagination-container" }
const _hoisted_8 = { class: "dashboard-section" }
const _hoisted_9 = { class: "kpi-grid" }
const _hoisted_10 = { class: "kpi-label" }
const _hoisted_11 = { class: "kpi-value" }
const _hoisted_12 = { class: "kpi-note" }
const _hoisted_13 = { class: "chart-grid chart-grid-main" }
const _hoisted_14 = { class: "chart-card chart-card-wide" }
const _hoisted_15 = { class: "chart-heading" }
const _hoisted_16 = {
  key: 0,
  class: "trend-chart-scroll"
}
const _hoisted_17 = { class: "chart-card chart-card-wide" }
const _hoisted_18 = { class: "chart-heading" }
const _hoisted_19 = {
  key: 0,
  class: "ranking-chart-scroll"
}
const _hoisted_20 = { class: "chart-grid" }
const _hoisted_21 = { class: "chart-card" }
const _hoisted_22 = { class: "chart-heading" }
const _hoisted_23 = { class: "chart-card" }
const _hoisted_24 = { class: "chart-card" }
const _hoisted_25 = { class: "chart-card inventory-card" }
const _hoisted_26 = {
  key: 0,
  class: "inventory-empty"
}
const _hoisted_27 = { class: "inventory-kpis" }
const _hoisted_28 = {
  key: 0,
  class: "ranking-chart-scroll inventory-chart"
}

import { computed, onMounted, reactive, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import {
    SearchOutlined,
    ReloadOutlined,
    DownloadOutlined,
    ArrowLeftOutlined,
  } from '@ant-design/icons-vue';
  import { message } from 'ant-design-vue';
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs, { type Dayjs } from 'dayjs';
  import type { EChartsCoreOption } from 'echarts/core';
  import { restoreSelectedShop, cacheSelectedShop } from '@/utils/selectedShop';
  import BaseChart from '@/components/BaseChart.vue';
  import { fetchCategoryItemList, fetchCategoryList } from '@/service/food';
  import { getOrderFoodReport, getOrderFoodReportSum } from '@/service/order';
  import { fetchShopList } from '@/service/base';
  import type { FoodStockItemModel } from '@/model/food';
  import type {
    OrderFoodReportModel,
    OrderFoodReportSumModel,
    OrderReportDashboardModel,
  } from '@/model/order';
  import { export_json_to_excel } from '@/utils/Export2Excel';
  import {
    aggregateFoodCategoryComposition,
    aggregateOrderReport,
    aggregateOrderReportPeriodTrend,
    aggregateOrderReportTrend,
  } from '@/utils/orderReport';
  import type { OrderReportBusinessPeriod, OrderReportTrendGranularity } from '@/utils/orderReport';

  const DASHBOARD_ROW_LIMIT = 10000;
  const INVENTORY_ROW_LIMIT = 10000;
  interface ShopOption {
    shopId?: number;
    shopName?: string;
  }

  interface InventorySummary {
    totalStock: number;
    outOfStock: number;
    lowStock: number;
  }

  interface FoodCategoryOption {
    shopFoodCategoryId?: number;
    categoryName?: string;
  }

  interface ReportFilterModel {
    shopId?: number;
    orderStatuss?: number[];
    orderNo?: string;
    paymentStatuss?: number[];
    paymentMethodName?: string;
    shopFoodName?: string;
    orderType?: number;
  }

  interface ReportRequestModel {
    pageNum: number;
    pageSize: number;
    data: ReportFilterModel;
    createtimeBegin: string;
    createtimeEnd: string;
  }

  // 订单状态：1已点餐、2待出餐、8已出餐、10已完成、999已取消
  
export default /*@__PURE__*/_defineComponent({
  __name: 'OrderReportView',
  setup(__props) {

  const router = useRouter();
  const CHART_COLORS = [
    '#2563eb',
    '#d97706',
    '#7c3aed',
    '#64748b',
    '#db2777',
    '#0891b2',
    '#65a30d',
    '#ea580c',
    '#4f46e5',
    '#0f766e',
  ];

  const orderStatusOptions = [
    { value: 1, label: '已点餐' },
    { value: 2, label: '待出餐' },
    { value: 8, label: '已出餐' },
    { value: 10, label: '已完成' },
    { value: 999, label: '已取消' },
  ];

  // 支付状态：0待支付、5部分支付、10已支付（与查询条件 data.paymentStatuss 一致）
  const paymentStatusOptions = [
    { value: 0, label: '待支付' },
    { value: 5, label: '部分支付' },
    { value: 10, label: '已支付' },
  ];

  const paymentMethodOptions = [
    { value: 1, label: '微信' },
    { value: 2, label: '支付宝' },
    { value: 3, label: '银行卡' },
    { value: 4, label: 'POS' },
    { value: 5, label: '挂账' },
    { value: 6, label: 'B扫C支付' },
    { value: 7, label: '现金' },
    { value: 100, label: '餐券' },
  ];

  // 报表列：有状态/类型名称的均用名称字段，不做转换。冻结列需放最前且 scroll.x 为具体数值
  // 顺序：创建时间, 订单编号, 订单类型, 收款/退款, 餐厅, 桌台, 订单状态, 支付状态, 支付方式, 就餐类型, 分类, 菜品名称, 规格, 数量, 单价, 金额, 菜品状态, 完成时间, 发票状态, 退款状态
  const columns = [
    { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 160, fixed: 'left' },
    { title: '订单编号', dataIndex: 'orderNo', key: 'orderNo', width: 160, fixed: 'left' },
    { title: '订单类型', dataIndex: 'orderTypeName', key: 'orderTypeName', width: 100 },
    { title: '收款/退款', dataIndex: 'settleName', key: 'settleName', width: 100 },
    { title: '餐厅', dataIndex: 'shopName', key: 'shopName', width: 120 },
    { title: '桌台', dataIndex: 'tableName', key: 'tableName', width: 100 },
    { title: '订单状态', dataIndex: 'orderStatusName', key: 'orderStatusName', width: 100 },
    { title: '支付状态', dataIndex: 'paymentStatusName', key: 'paymentStatusName', width: 100 },
    { title: '支付方式', dataIndex: 'paymentMethodName', key: 'paymentMethodName', width: 110 },
    { title: '就餐类型', dataIndex: 'dineTypeName', key: 'dineTypeName', width: 100 },
    { title: '分类', dataIndex: 'shopFoodCategoryName', key: 'shopFoodCategoryName', width: 120 },
    { title: '菜品名称', dataIndex: 'shopFoodName', key: 'shopFoodName', width: 140 },
    { title: '规格', dataIndex: 'foodSpecName', key: 'foodSpecName', width: 100 },
    { title: '数量', dataIndex: 'quantity', key: 'quantity', width: 80 },
    { title: '单价', dataIndex: 'price', key: 'price', width: 90 },
    { title: '金额', dataIndex: 'amount', key: 'amount', width: 90 },
    { title: '菜品状态', dataIndex: 'foodStatusName', key: 'foodStatusName', width: 100 },
    { title: '完成时间', dataIndex: 'completeTime', key: 'completeTime', width: 160 },
    { title: '发票状态', dataIndex: 'invoiceStatusName', key: 'invoiceStatusName', width: 100 },
    { title: '退款状态', dataIndex: 'refundStatusName', key: 'refundStatusName', width: 100 },
    { title: '取消备注', dataIndex: 'cancelRemark', key: 'cancelRemark', width: 160 },
  ];

  const loading = ref(false);
  const dashboardLoading = ref(false);
  const detailSummaryLoading = ref(false);
  const inventoryLoading = ref(false);
  const exportLoading = ref(false);
  const shopList = ref<ShopOption[]>([]);
  const tableData = ref<OrderFoodReportModel[]>([]);
  const total = ref(0);
  const dashboardTruncated = ref(false);
  const dashboardError = ref('');
  const activeReportTab = ref<'dashboard' | 'detail'>('detail');
  const inventoryError = ref('');
  const rankingMetric = ref<'quantity' | 'netAmount' | 'lowQuantity'>('quantity');
  const trendGranularity = ref<OrderReportTrendGranularity>('day');
  const dashboardData = ref<OrderReportDashboardModel>({
    kpi: {
      effectiveOrderCount: 0,
      netRevenue: 0,
      soldFoodQuantity: 0,
      averageOrderAmount: 0,
    },
    trend: [],
    foodRanking: [],
    paymentComposition: [],
    cancellation: {
      totalOrderCount: 0,
      cancelledOrderCount: 0,
      composition: [],
    },
  });
  const detailSummary = ref<OrderFoodReportSumModel>({
    totalOrderCount: 0,
    cancelOrderCount: 0,
    totalAmount: 0,
    totalFoodQuantity: 0,
    cancelFoodQuantity: 0,
  });
  const dashboardRows = ref<OrderFoodReportModel[]>([]);
  const inventoryFoods = ref<FoodStockItemModel[]>([]);
  const foodCategories = ref<FoodCategoryOption[]>([]);
  const dateRange = ref<[Dayjs, Dayjs] | null>(null);

  const formatCurrency = (value: number) =>
    `¥${value.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const kpiCards = computed(() => [
    {
      label: '有效订单',
      value: dashboardData.value.kpi.effectiveOrderCount.toLocaleString('zh-CN'),
      note: '正常及部分取消订单',
    },
    {
      label: '营业额',
      value: formatCurrency(dashboardData.value.kpi.netRevenue),
      note: '查询范围内的营业收入',
    },
    {
      label: '菜品净数量',
      value: dashboardData.value.kpi.soldFoodQuantity.toLocaleString('zh-CN'),
      note: '查询范围内的菜品数量',
    },
    {
      label: '客单价',
      value: formatCurrency(dashboardData.value.kpi.averageOrderAmount),
      note: '营业额 / 有效订单',
    },
  ]);

  const isLowSalesRanking = computed(() => rankingMetric.value === 'lowQuantity');
  const rankingTitle = computed(() =>
    isLowSalesRanking.value ? '菜品销量倒排 Top 30' : '菜品经营排行 Top 20',
  );
  const rankingDescription = computed(() =>
    isLowSalesRanking.value
      ? '仅展示有销量的菜品，按销量从低到高排列'
      : '金额与数量按查询范围内的明细汇总',
  );
  const rankedFoods = computed(() => {
    const foods = [...dashboardData.value.foodRanking];
    if (isLowSalesRanking.value) {
      return foods
        .filter((item) => item.quantity > 0)
        .sort(
          (left, right) =>
            left.quantity - right.quantity || left.name.localeCompare(right.name, 'zh-CN'),
        )
        .slice(0, 30);
    }
    const metric = rankingMetric.value === 'netAmount' ? 'netAmount' : 'quantity';
    return foods
      .filter((item) => item.quantity !== 0 || item.netAmount !== 0)
      .sort((left, right) => {
        const difference = right[metric] - left[metric];
        return difference || left.name.localeCompare(right.name, 'zh-CN');
      })
      .slice(0, 20);
  });

  const normalInventoryFoods = computed(() =>
    inventoryFoods.value.filter((item) => Number(item.shopFoodStatus) === 0),
  );
  const categoryByFoodName = computed(() => {
    const categoryNames = new Map<number, string>();
    foodCategories.value.forEach((item) => {
      if (item.shopFoodCategoryId != null && item.categoryName) {
        categoryNames.set(item.shopFoodCategoryId, item.categoryName);
      }
    });
    const result = new Map<string, string>();
    inventoryFoods.value.forEach((item) => {
      const foodName = (item.shopFoodName || item.foodName || '').trim();
      const categoryName =
        item.shopFoodCategoryId == null ? undefined : categoryNames.get(item.shopFoodCategoryId);
      if (foodName && categoryName && !result.has(foodName)) result.set(foodName, categoryName);
    });
    return result;
  });
  const foodCategoryComposition = computed(() =>
    aggregateFoodCategoryComposition(dashboardRows.value, categoryByFoodName.value),
  );
  const trendData = computed(() =>
    aggregateOrderReportTrend(
      dashboardRows.value,
      trendGranularity.value === 'hour' ? 'hour' : 'day',
    ),
  );
  const periodTrendData = computed(() => aggregateOrderReportPeriodTrend(dashboardRows.value));
  const businessPeriods: OrderReportBusinessPeriod[] = [
    '早 00:00-09:30',
    '中 09:30-14:00',
    '晚 14:00-24:00',
  ];
  const periodTrendDates = computed(() =>
    Array.from(new Set(periodTrendData.value.map((item) => item.date))).sort(),
  );
  const periodTrendMap = computed(
    () =>
      new Map(periodTrendData.value.map((item) => [`${item.date}|${item.period}`, item] as const)),
  );
  const hasTrendData = computed(() =>
    trendGranularity.value === 'period'
      ? periodTrendData.value.length > 0
      : trendData.value.length > 0,
  );
  const trendDescription = computed(() => {
    if (trendGranularity.value === 'hour') return '日期与小时热力矩阵，颜色越深营业额越高';
    if (trendGranularity.value === 'period') {
      return '日期与早、中、晚时段热力矩阵，显示营业额、有效订单数与客单价';
    }
    return '营业额与有效订单数，按订单创建日期汇总';
  });
  const hourlyTrendDates = computed(() =>
    Array.from(
      new Set(
        trendData.value
          .map((item) => item.date.split(' ')[0])
          .filter((date) => /^\d{4}-\d{2}-\d{2}$/.test(date)),
      ),
    ).sort(),
  );
  const hourlyTrendHours = computed(() =>
    Array.from(
      new Set(
        trendData.value
          .map((item) => item.date.split(' ')[1])
          .filter((hour): hour is string => Boolean(hour)),
      ),
    ).sort(),
  );
  const hourlyTrendMap = computed(() => new Map(trendData.value.map((item) => [item.date, item])));
  const hourlyTrendSummary = computed(() =>
    hourlyTrendHours.value.map((hour) =>
      trendData.value.reduce(
        (summary, item) => {
          if (item.date.endsWith(` ${hour}`)) {
            summary.amount += item.netRevenue;
            summary.orderCount += item.orderCount;
          }
          return summary;
        },
        { amount: 0, orderCount: 0 },
      ),
    ),
  );
  const periodTrendSummary = computed(() =>
    businessPeriods.map((period) => {
      const summary = periodTrendData.value.reduce(
        (result, item) => {
          if (item.period === period) {
            result.amount += item.amount;
            result.orderCount += item.orderCount;
          }
          return result;
        },
        { amount: 0, orderCount: 0 },
      );
      return {
        ...summary,
        averageOrderAmount:
          summary.orderCount > 0
            ? Math.round((summary.amount / summary.orderCount) * 100) / 100
            : 0,
      };
    }),
  );
  const lowStockFoods = computed(() =>
    [...normalInventoryFoods.value]
      .sort((left, right) => {
        const stockDifference = Number(left.stockQuantity || 0) - Number(right.stockQuantity || 0);
        const leftName = left.shopFoodName || left.foodName || '';
        const rightName = right.shopFoodName || right.foodName || '';
        return stockDifference || leftName.localeCompare(rightName, 'zh-CN');
      })
      .slice(0, 20),
  );
  const inventorySummary = computed<InventorySummary>(() =>
    normalInventoryFoods.value.reduce(
      (summary, item) => {
        const stock = Math.max(0, Number(item.stockQuantity) || 0);
        summary.totalStock += stock;
        if (stock === 0) summary.outOfStock += 1;
        else if (stock <= 10) summary.lowStock += 1;
        return summary;
      },
      { totalStock: 0, outOfStock: 0, lowStock: 0 },
    ),
  );

  const baseTooltip = {
    trigger: 'axis',
    axisPointer: { type: 'shadow' },
  };
  const formatTrendDate = (value: string): string => {
    const date = dayjs(value);
    return date.isValid() ? date.format('MM-DD') : value;
  };
  const dayTrendChartOption = computed<EChartsCoreOption>(() => ({
    color: CHART_COLORS.slice(0, 2),
    tooltip: { trigger: 'axis' },
    legend: { top: 0, data: ['营业额', '有效订单'] },
    grid: { top: 62, right: 64, bottom: 55, left: 72 },
    xAxis: {
      type: 'category',
      data: trendData.value.map((item) => formatTrendDate(item.date)),
      axisLabel: { rotate: trendData.value.length > 8 ? 35 : 0 },
    },
    yAxis: [
      { type: 'value', name: '金额（元）', splitLine: { lineStyle: { color: '#e5e7eb' } } },
      { type: 'value', name: '订单（单）', minInterval: 1, splitLine: { show: false } },
    ],
    series: [
      {
        name: '营业额',
        type: 'bar',
        data: trendData.value.map((item) => item.netRevenue),
        itemStyle: { color: '#2563eb' },
        label: {
          show: true,
          position: 'top',
          color: '#1e3a8a',
          fontSize: 11,
          formatter: ({ value }: { value: number }) => `¥${Number(value).toFixed(2)}`,
        },
      },
      {
        name: '有效订单',
        type: 'line',
        yAxisIndex: 1,
        smooth: false,
        symbol: 'circle',
        data: trendData.value.map((item) => item.orderCount),
        lineStyle: { color: '#d97706', width: 2 },
        itemStyle: { color: '#fff', borderColor: '#d97706', borderWidth: 2 },
        label: {
          show: true,
          position: 'top',
          distance: 10,
          color: '#92400e',
          fontSize: 11,
          formatter: ({ value }: { value: number }) => `${value}单`,
        },
      },
    ],
  }));
  const hourlyTrendChartOption = computed<EChartsCoreOption>(() => ({
    tooltip: {
      position: 'top',
      formatter: ({ data }: { data: number[] }) => {
        const date = hourlyTrendDates.value[data[1]];
        const hour = hourlyTrendHours.value[data[0]] || '';
        const rowName = date ? formatTrendDate(date) : '汇总';
        return `${rowName} ${hour}<br/>营业额：¥${Number(data[2]).toFixed(2)}<br/>有效订单：${
          data[3]
        }单`;
      },
    },
    grid: { top: 12, right: 28, bottom: 72, left: 72 },
    xAxis: {
      type: 'category',
      name: '小时',
      data: hourlyTrendHours.value,
      splitArea: { show: true },
      axisLabel: { interval: 0, fontSize: 11 },
    },
    yAxis: {
      type: 'category',
      name: '日期',
      data: [...hourlyTrendDates.value.map(formatTrendDate), '汇总'],
      splitArea: { show: true },
      axisLabel: {
        interval: 0,
        formatter: (value: string) => (value === '汇总' ? '{summary|汇总}' : value),
        rich: { summary: { fontWeight: 'bold', color: '#1d4ed8' } },
      },
    },
    visualMap: {
      min: 0,
      max: Math.max(1, ...trendData.value.map((item) => Math.max(0, item.netRevenue))),
      calculable: true,
      orient: 'horizontal',
      left: 'center',
      bottom: 4,
      text: ['金额高', '金额低'],
      inRange: { color: ['#eff6ff', '#93c5fd', '#2563eb'] },
    },
    series: [
      {
        type: 'heatmap',
        data: [
          ...hourlyTrendDates.value.flatMap((date, dateIndex) =>
            hourlyTrendHours.value.map((hour, hourIndex) => {
              const item = hourlyTrendMap.value.get(`${date} ${hour}`);
              return [hourIndex, dateIndex, item?.netRevenue ?? 0, item?.orderCount ?? 0];
            }),
          ),
          ...hourlyTrendSummary.value.map((item, hourIndex) => [
            hourIndex,
            hourlyTrendDates.value.length,
            Math.round(item.amount * 100) / 100,
            item.orderCount,
          ]),
        ],
        label: {
          show: true,
          color: '#0f172a',
          fontSize: 10,
          lineHeight: 14,
          formatter: ({ data }: { data: number[] }) =>
            data[2] === 0 && data[3] === 0 ? '' : `¥${Number(data[2]).toFixed(0)}\n${data[3]}单`,
        },
        itemStyle: { borderColor: '#fff', borderWidth: 2 },
      },
    ],
  }));
  const periodTrendChartOption = computed<EChartsCoreOption>(() => ({
    tooltip: {
      position: 'top',
      formatter: ({ data }: { data: number[] }) => {
        const date = periodTrendDates.value[data[1]];
        const period = businessPeriods[data[0]] || '';
        const rowName = date ? formatTrendDate(date) : '汇总';
        return `${rowName} ${period}<br/>营业额：¥${Number(data[2]).toFixed(2)}<br/>有效订单：${
          data[3]
        }单<br/>客单价：¥${Number(data[4]).toFixed(2)}`;
      },
    },
    grid: { top: 12, right: 28, bottom: 72, left: 72 },
    xAxis: {
      type: 'category',
      data: businessPeriods,
      splitArea: { show: true },
      axisLabel: { interval: 0 },
    },
    yAxis: {
      type: 'category',
      name: '日期',
      data: [...periodTrendDates.value.map(formatTrendDate), '汇总'],
      splitArea: { show: true },
      axisLabel: {
        interval: 0,
        formatter: (value: string) => (value === '汇总' ? '{summary|汇总}' : value),
        rich: { summary: { fontWeight: 'bold', color: '#1d4ed8' } },
      },
    },
    visualMap: {
      min: 0,
      max: Math.max(1, ...periodTrendData.value.map((item) => Math.max(0, item.amount))),
      calculable: true,
      orient: 'horizontal',
      left: 'center',
      bottom: 4,
      text: ['金额高', '金额低'],
      inRange: { color: ['#eff6ff', '#93c5fd', '#2563eb'] },
    },
    series: [
      {
        type: 'heatmap',
        data: [
          ...periodTrendDates.value.flatMap((date, dateIndex) =>
            businessPeriods.map((period, periodIndex) => {
              const item = periodTrendMap.value.get(`${date}|${period}`);
              return [
                periodIndex,
                dateIndex,
                item?.amount ?? 0,
                item?.orderCount ?? 0,
                item?.averageOrderAmount ?? 0,
              ];
            }),
          ),
          ...periodTrendSummary.value.map((item, periodIndex) => [
            periodIndex,
            periodTrendDates.value.length,
            Math.round(item.amount * 100) / 100,
            item.orderCount,
            item.averageOrderAmount,
          ]),
        ],
        label: {
          show: true,
          color: '#0f172a',
          fontSize: 10,
          lineHeight: 14,
          formatter: ({ data }: { data: number[] }) =>
            data[2] === 0 && data[3] === 0
              ? ''
              : `¥${Number(data[2]).toFixed(0)} · ${data[3]}单\n客单¥${Number(data[4]).toFixed(0)}`,
        },
        itemStyle: { borderColor: '#fff', borderWidth: 2 },
      },
    ],
  }));
  const trendChartOption = computed<EChartsCoreOption>(() =>
    trendGranularity.value === 'hour'
      ? hourlyTrendChartOption.value
      : trendGranularity.value === 'period'
      ? periodTrendChartOption.value
      : dayTrendChartOption.value,
  );
  const trendChartWidth = computed(() => {
    if (trendGranularity.value === 'hour') {
      return `${Math.max(760, hourlyTrendHours.value.length * 54)}px`;
    }
    if (trendGranularity.value === 'period') {
      return '760px';
    }
    return `${Math.max(760, trendData.value.length * 92)}px`;
  });
  const trendChartHeight = computed(() => {
    if (trendGranularity.value === 'hour') {
      return `${Math.max(360, (hourlyTrendDates.value.length + 1) * 46 + 100)}px`;
    }
    if (trendGranularity.value === 'period') {
      return `${Math.max(360, (periodTrendDates.value.length + 1) * 54 + 100)}px`;
    }
    return '360px';
  });
  const wrapChartLabel = (value: string, charactersPerLine = 14): string => {
    const characters = Array.from(value);
    const lines: string[] = [];
    for (let index = 0; index < characters.length; index += charactersPerLine) {
      lines.push(characters.slice(index, index + charactersPerLine).join(''));
    }
    return lines.join('\n');
  };
  const getChartRowHeight = (labels: string[]): number => {
    const maxLineCount = Math.max(
      1,
      ...labels.map((label) => Math.ceil(Array.from(label).length / 14)),
    );
    return Math.max(38, maxLineCount * 18 + 12);
  };
  const foodRankingChartOption = computed<EChartsCoreOption>(() => {
    const data = [...rankedFoods.value].reverse();
    const isAmount = rankingMetric.value === 'netAmount';
    return {
      color: ['#2563eb'],
      tooltip: {
        ...baseTooltip,
        valueFormatter: (value: unknown) =>
          isAmount ? formatCurrency(Number(value) || 0) : `${Number(value) || 0} 份`,
      },
      grid: { top: 12, right: 76, bottom: 30, left: 250, containLabel: false },
      xAxis: {
        type: 'value',
        name: isAmount ? '元' : '份',
        splitLine: { lineStyle: { color: '#e5e7eb' } },
      },
      yAxis: {
        type: 'category',
        data: data.map((item) => item.name),
        axisLabel: {
          width: 220,
          lineHeight: 18,
          align: 'right',
          formatter: (value: string) => wrapChartLabel(value),
        },
      },
      series: [
        {
          type: 'bar',
          data: data.map((item) => (isAmount ? item.netAmount : item.quantity)),
          barMaxWidth: 18,
          label: {
            show: true,
            position: 'right',
            formatter: ({ value }: { value: number }) =>
              isAmount ? `¥${Number(value).toFixed(2)}` : String(value),
          },
        },
      ],
    };
  });
  const rankingChartHeight = computed(() => {
    const labels = rankedFoods.value.map((item) => item.name);
    return `${Math.max(360, labels.length * getChartRowHeight(labels) + 50)}px`;
  });

  const buildPieOption = (
    data: Array<{ name: string; value: number }>,
    unit: string,
  ): EChartsCoreOption => ({
    color: CHART_COLORS,
    tooltip: { trigger: 'item', formatter: `{b}<br/>{c}${unit}（{d}%）` },
    legend: { type: 'scroll', bottom: 0 },
    series: [
      {
        type: 'pie',
        radius: ['42%', '68%'],
        center: ['50%', '44%'],
        data,
        label: { formatter: '{b}\n{d}%' },
        itemStyle: { borderColor: '#fff', borderWidth: 2 },
      },
    ],
  });
  const paymentChartOption = computed<EChartsCoreOption>(() => ({
    color: CHART_COLORS,
    tooltip: {
      trigger: 'item',
      formatter: ({ name, value, percent }: { name: string; value: number; percent: number }) => {
        const item = dashboardData.value.paymentComposition.find((entry) => entry.name === name);
        return `${name}<br/>金额：${formatCurrency(Number(value))}（${percent}%）<br/>订单：${
          item?.orderCount ?? 0
        }单<br/>客单价：${formatCurrency(item?.averageOrderAmount ?? 0)}`;
      },
    },
    legend: { type: 'scroll', bottom: 0 },
    series: [
      {
        type: 'pie',
        radius: ['42%', '68%'],
        center: ['50%', '44%'],
        data: dashboardData.value.paymentComposition,
        label: {
          formatter: ({ name, percent }: { name: string; percent: number }) => {
            const item = dashboardData.value.paymentComposition.find(
              (entry) => entry.name === name,
            );
            return `${name} ${percent}%\n客单${formatCurrency(item?.averageOrderAmount ?? 0)}`;
          },
        },
        itemStyle: { borderColor: '#fff', borderWidth: 2 },
      },
    ],
  }));
  const cancellationChartOption = computed<EChartsCoreOption>(() => ({
    color: ['#16a34a', '#94a3b8', '#dc2626', '#f59e0b'],
    tooltip: { trigger: 'item', formatter: '{b}<br/>{c}单（{d}%）' },
    legend: { type: 'scroll', bottom: 0 },
    title: {
      text: String(dashboardData.value.cancellation.totalOrderCount),
      subtext: '总订单',
      left: 'center',
      top: '36%',
      textStyle: { fontSize: 24, color: '#0f172a' },
      subtextStyle: { fontSize: 12, color: '#64748b' },
    },
    series: [
      {
        type: 'pie',
        radius: ['48%', '70%'],
        center: ['50%', '44%'],
        data: dashboardData.value.cancellation.composition,
        label: { formatter: '{b}\n{c}单 {d}%' },
        itemStyle: { borderColor: '#fff', borderWidth: 2 },
      },
    ],
  }));
  const foodCategoryChartOption = computed<EChartsCoreOption>(() =>
    buildPieOption(foodCategoryComposition.value, '份'),
  );
  const inventoryChartOption = computed<EChartsCoreOption>(() => ({
    color: ['#d97706'],
    tooltip: { ...baseTooltip, valueFormatter: (value: unknown) => `${Number(value) || 0} 份` },
    grid: { top: 12, right: 68, bottom: 30, left: 240 },
    xAxis: {
      type: 'value',
      min: 0,
      name: '份',
      minInterval: 1,
      splitLine: { lineStyle: { color: '#e5e7eb' } },
    },
    yAxis: {
      type: 'category',
      inverse: true,
      data: lowStockFoods.value.map((item) => item.shopFoodName || item.foodName || '未知菜品'),
      axisLabel: {
        width: 210,
        lineHeight: 18,
        align: 'right',
        formatter: (value: string) => wrapChartLabel(value),
      },
    },
    series: [
      {
        type: 'bar',
        barMaxWidth: 18,
        data: lowStockFoods.value.map((item) => Number(item.stockQuantity) || 0),
        label: { show: true, position: 'right' },
      },
    ],
  }));
  const inventoryChartHeight = computed(() => {
    const labels = lowStockFoods.value.map(
      (item) => item.shopFoodName || item.foodName || '未知菜品',
    );
    return `${Math.max(360, labels.length * getChartRowHeight(labels) + 50)}px`;
  });

  const queryParams = reactive({
    createtimeBegin: '',
    createtimeEnd: '',
    pageNum: 1,
    pageSize: 20,
    data: {
      shopId: undefined as number | undefined,
      orderStatuss: [] as number[],
      orderNo: '',
      paymentStatuss: [] as number[],
      paymentMethodName: undefined as string | undefined,
      shopFoodName: '',
      orderType: undefined as number | undefined,
    },
  });

  const formatDateTime = (dateStr: string | Date | undefined) => {
    if (!dateStr) return '-';
    return dayjs(dateStr).format('YYYY-MM-DD HH:mm:ss');
  };

  const formatDate = (dateStr: string | Date | undefined) => {
    if (!dateStr) return '';
    return dayjs(dateStr).format('YYYY-MM-DD');
  };

  const formatTime = (dateStr: string | Date | undefined) => {
    if (!dateStr) return '';
    return dayjs(dateStr).format('HH:mm:ss');
  };

  const toExcelNumber = (value: unknown): number => {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? Math.round(value * 100) / 100 : 0;
    }
    const normalized =
      typeof value === 'string' ? Number(value.replace(/,/g, '').trim()) : Number(value);
    return Number.isFinite(normalized) ? Math.round(normalized * 100) / 100 : 0;
  };

  // 保留用户选择的时分秒，按精确时间范围查询
  const handleDateRangeChange = (dates: [Dayjs, Dayjs] | null) => {
    if (dates && dates[0] && dates[1]) {
      queryParams.createtimeBegin = dates[0].format('YYYY-MM-DD HH:mm:ss');
      queryParams.createtimeEnd = dates[1].format('YYYY-MM-DD HH:mm:ss');
    }
  };

  const loadShopList = async () => {
    try {
      const res = await fetchShopList({
        pageNum: 1,
        pageSize: 999,
        data: { shopStatus: 0 },
      });
      if (res.code === 200) {
        shopList.value = res.result?.list || [];
      }
    } catch (e) {
      console.error('加载餐厅列表失败:', e);
      message.error('加载餐厅列表失败');
    }
  };

  const handleShopChange = (shopId: number | undefined) => {
    cacheSelectedShop(shopId);
  };

  const buildRequestParams = (overrides?: { pageNum?: number; pageSize?: number }) => {
    const params: ReportRequestModel = {
      pageNum: overrides?.pageNum ?? queryParams.pageNum,
      pageSize: overrides?.pageSize ?? queryParams.pageSize,
      data: {},
      createtimeBegin: queryParams.createtimeBegin,
      createtimeEnd: queryParams.createtimeEnd,
    };
    if (queryParams.data.shopId !== undefined && queryParams.data.shopId !== null) {
      params.data.shopId = queryParams.data.shopId;
    }
    if (Array.isArray(queryParams.data.orderStatuss) && queryParams.data.orderStatuss.length > 0) {
      params.data.orderStatuss = queryParams.data.orderStatuss;
    }
    if (queryParams.data.orderNo && String(queryParams.data.orderNo).trim()) {
      params.data.orderNo = String(queryParams.data.orderNo).trim();
    }
    if (queryParams.data.orderType !== undefined && queryParams.data.orderType !== null) {
      params.data.orderType = queryParams.data.orderType;
    }
    if (
      Array.isArray(queryParams.data.paymentStatuss) &&
      queryParams.data.paymentStatuss.length > 0
    ) {
      params.data.paymentStatuss = queryParams.data.paymentStatuss;
    }
    const paymentMethodName = queryParams.data.paymentMethodName?.trim();
    if (paymentMethodName) {
      params.data.paymentMethodName = paymentMethodName;
    }
    if (queryParams.data.shopFoodName.trim()) {
      params.data.shopFoodName = queryParams.data.shopFoodName.trim();
    }
    return params;
  };

  const resetDashboard = () => {
    dashboardData.value = aggregateOrderReport([]);
    dashboardRows.value = [];
    dashboardTruncated.value = false;
  };

  const resetDetailSummary = () => {
    detailSummary.value = {
      totalOrderCount: 0,
      cancelOrderCount: 0,
      totalAmount: 0,
      totalFoodQuantity: 0,
      cancelFoodQuantity: 0,
    };
  };

  const loadDetailSummary = async () => {
    detailSummaryLoading.value = true;
    try {
      const response = await getOrderFoodReportSum(buildRequestParams({ pageNum: 1 }));
      if (response.code !== 200 || !response.result) {
        resetDetailSummary();
        message.error(response.msg || '查询汇总数据失败');
        return;
      }
      detailSummary.value = {
        totalOrderCount: Number(response.result.totalOrderCount || 0),
        cancelOrderCount: Number(response.result.cancelOrderCount || 0),
        totalAmount: Number(response.result.totalAmount || 0),
        totalFoodQuantity: Number(response.result.totalFoodQuantity || 0),
        cancelFoodQuantity: Number(response.result.cancelFoodQuantity || 0),
      };
    } catch (error) {
      console.error('加载订单报表汇总失败:', error);
      resetDetailSummary();
      message.error('加载订单报表汇总失败');
    } finally {
      detailSummaryLoading.value = false;
    }
  };

  const loadDashboardData = async () => {
    dashboardLoading.value = true;
    dashboardError.value = '';
    try {
      const response = await getOrderFoodReport(
        buildRequestParams({ pageNum: 1, pageSize: DASHBOARD_ROW_LIMIT }),
      );
      if (response.code !== 200) {
        resetDashboard();
        dashboardError.value = response.msg || '运营图表数据加载失败';
        return;
      }
      dashboardData.value = aggregateOrderReport(response.result?.list || []);
      dashboardRows.value = response.result?.list || [];
      dashboardTruncated.value = Number(response.result?.total || 0) > DASHBOARD_ROW_LIMIT;
    } catch (error) {
      console.error('加载运营图表数据失败:', error);
      resetDashboard();
      dashboardError.value = '运营图表数据加载失败，请稍后重试';
    } finally {
      dashboardLoading.value = false;
    }
  };

  const loadInventoryData = async () => {
    inventoryFoods.value = [];
    foodCategories.value = [];
    inventoryError.value = '';
    const shopId = queryParams.data.shopId;
    if (!shopId) return;
    try {
      inventoryLoading.value = true;
      const [foodResponse, categoryResponse] = await Promise.all([
        fetchCategoryItemList({
          pageNum: 1,
          pageSize: INVENTORY_ROW_LIMIT,
          data: { shopId },
        }),
        fetchCategoryList({
          pageNum: 1,
          pageSize: INVENTORY_ROW_LIMIT,
          data: { shopId, categoryStatus: 0 },
        }),
      ]);
      if (foodResponse.code !== 200) {
        inventoryError.value = foodResponse.msg || '库存数据加载失败';
        return;
      }
      inventoryFoods.value = (foodResponse.result?.list || []) as FoodStockItemModel[];
      if (categoryResponse.code === 200) {
        foodCategories.value = (categoryResponse.result?.list || []) as FoodCategoryOption[];
      } else {
        console.error('加载菜品分类失败:', categoryResponse.msg);
      }
    } catch (error) {
      console.error('加载库存概览失败:', error);
      inventoryError.value = '库存数据加载失败，请稍后重试';
    } finally {
      inventoryLoading.value = false;
    }
  };

  const loadReportData = async (refreshDashboard = true) => {
    if (!queryParams.data.shopId) {
      tableData.value = [];
      total.value = 0;
      message.warning('请选择餐厅');
      return;
    }
    const auxiliaryPromise = refreshDashboard
      ? Promise.all([loadDashboardData(), loadInventoryData(), loadDetailSummary()])
      : Promise.resolve();
    try {
      loading.value = true;
      const params = buildRequestParams();
      const res = await getOrderFoodReport(params);
      if (res.code === 200) {
        tableData.value = res.result?.list || [];
        total.value = res.result?.total ?? 0;
      } else {
        message.error(res.msg || '查询失败');
        tableData.value = [];
        total.value = 0;
      }
    } catch (e) {
      console.error('加载订单报表失败:', e);
      message.error('加载订单报表失败');
      tableData.value = [];
      total.value = 0;
    } finally {
      loading.value = false;
      await auxiliaryPromise;
    }
  };

  const handleSearch = () => {
    if (!queryParams.createtimeBegin || !queryParams.createtimeEnd) {
      message.warning('请选择创建时间');
      return;
    }

    queryParams.pageNum = 1;
    loadReportData();
  };

  const handleReset = () => {
    const today = dayjs();
    queryParams.pageNum = 1;
    queryParams.pageSize = 20;
    queryParams.createtimeBegin = today.startOf('day').format('YYYY-MM-DD HH:mm:ss');
    queryParams.createtimeEnd = today.endOf('day').format('YYYY-MM-DD HH:mm:ss');
    queryParams.data.orderStatuss = [];
    queryParams.data.orderNo = '';
    queryParams.data.paymentStatuss = [];
    queryParams.data.paymentMethodName = undefined;
    queryParams.data.shopFoodName = '';
    queryParams.data.orderType = undefined;
    dateRange.value = [today.startOf('day'), today.endOf('day')];
    loadReportData();
  };

  const handlePageChange = (page: number) => {
    queryParams.pageNum = page;
    loadReportData(false);
  };

  const handlePageSizeChange = (_current: number, size: number) => {
    queryParams.pageNum = 1;
    queryParams.pageSize = size;
    loadReportData(false);
  };

  const handleExport = async () => {
    if (!queryParams.data.shopId) {
      message.warning('请选择餐厅');
      return;
    }
    try {
      exportLoading.value = true;
      const params = buildRequestParams({ pageNum: 1, pageSize: 100000 });
      const res = await getOrderFoodReport(params);
      const list = res.code === 200 ? res.result?.list || [] : [];
      if (list.length === 0) {
        message.info('当前查询条件下无数据可导出');
        return;
      }
      // 导出列顺序与表格列保持一致（时间在 Excel 中拆成日期 + 时间两列）
      const header = [
        '创建日期',
        '创建时间',
        '订单编号',
        '订单类型',
        '收款/退款',
        '餐厅',
        '桌台',
        '订单状态',
        '支付状态',
        '支付方式',
        '就餐类型',
        '分类',
        '菜品名称',
        '规格',
        '数量',
        '单价',
        '金额',
        '菜品状态',
        '完成日期',
        '完成时间',
        '发票状态',
        '退款状态',
        '取消备注',
      ];
      const exportData = list.map((row: OrderFoodReportModel) => [
        formatDate(row.createTime),
        formatTime(row.createTime),
        row.orderNo ?? '',
        row.orderTypeName ?? '',
        row.settleName ?? '',
        row.shopName ?? '',
        row.tableName ?? '',
        row.orderStatusName ?? '',
        row.paymentStatusName ?? '',
        row.paymentMethodName ?? '',
        row.dineTypeName ?? '',
        row.shopFoodCategoryName ?? '',
        row.shopFoodName ?? '',
        row.foodSpecName ?? '',
        row.quantity != null ? String(row.quantity).replace(/份/g, '') : '',
        toExcelNumber(row.price),
        toExcelNumber(row.amount),
        row.foodStatusName ?? '',
        formatDate(row.completeTime),
        formatTime(row.completeTime),
        row.invoiceStatusName ?? '',
        row.refundStatusName ?? '',
        row.cancelRemark ?? '',
      ]);
      const filename = `订单报表_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}`;
      export_json_to_excel({
        header,
        data: exportData,
        filename,
        autoWidth: true,
        bookType: 'xlsx',
      });
      message.success(`已导出 ${list.length} 条记录`);
    } catch (e) {
      console.error('导出失败:', e);
      message.error('导出失败');
    } finally {
      exportLoading.value = false;
    }
  };

  const goBack = () => {
    router.back();
  };

  onMounted(async () => {
    const today = dayjs();
    dateRange.value = [today.startOf('day'), today.endOf('day')];
    handleDateRangeChange(dateRange.value);
    await loadShopList();
    queryParams.data.shopId = restoreSelectedShop(shopList.value);
    loadReportData();
  });

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_config_provider, { locale: _unref(zhCN) }, {
      default: _withCtx(() => [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("button", {
            class: "page-back-btn",
            "aria-label": "返回",
            onClick: goBack
          }, [
            _createVNode(_unref(ArrowLeftOutlined))
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "page-title" }, "订单报表", -1))
        ]),
        _createVNode(_component_a_card, { bordered: false }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              model: queryParams,
              layout: "inline",
              class: "search-form",
              onSubmit: [
                handleSearch,
                _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
              ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "餐厅" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: queryParams.data.shopId,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.data.shopId) = $event)),
                      placeholder: "请选择餐厅",
                      disabled: "",
                      style: {"width":"200px"},
                      onChange: handleShopChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: shop.shopId,
                            value: shop.shopId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(shop.shopName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "订单状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: queryParams.data.orderStatuss,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.data.orderStatuss) = $event)),
                      placeholder: "请选择订单状态",
                      "allow-clear": "",
                      style: {"width":"160px"},
                      mode: "multiple",
                      "max-tag-count": 1
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderStatusOptions, (opt) => {
                          return _createVNode(_component_a_select_option, {
                            key: opt.value,
                            value: opt.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(opt.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "订单编码" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: queryParams.data.orderNo,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.data.orderNo) = $event)),
                      placeholder: "请输入订单编号",
                      "allow-clear": "",
                      style: {"width":"200px"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "订单类型" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: queryParams.data.orderType,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.data.orderType) = $event)),
                      placeholder: "请选择订单类型",
                      "allow-clear": "",
                      style: {"width":"160px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 0 }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode("自有系统", -1)
                          ])),
                          _: 1,
                          __: [15]
                        }),
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode("POS系统", -1)
                          ])),
                          _: 1,
                          __: [16]
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "支付状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: queryParams.data.paymentStatuss,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.data.paymentStatuss) = $event)),
                      placeholder: "请选择支付状态",
                      "allow-clear": "",
                      style: {"width":"160px"},
                      mode: "multiple",
                      "max-tag-count": 1
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentStatusOptions, (opt) => {
                          return _createVNode(_component_a_select_option, {
                            key: opt.value,
                            value: opt.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(opt.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "支付方式" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: queryParams.data.paymentMethodName,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryParams.data.paymentMethodName) = $event)),
                      placeholder: "请选择支付方式",
                      "allow-clear": "",
                      style: {"width":"160px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentMethodOptions, (opt) => {
                          return _createVNode(_component_a_select_option, {
                            key: opt.value,
                            value: opt.label
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(opt.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "菜名" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: queryParams.data.shopFoodName,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryParams.data.shopFoodName) = $event)),
                      placeholder: "请输入菜名",
                      "allow-clear": "",
                      style: {"width":"160px"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "创建时间",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      value: dateRange.value,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dateRange).value = $event)),
                      "show-time": { format: 'HH:mm:ss' },
                      format: "YYYY-MM-DD HH:mm:ss",
                      "allow-clear": false,
                      style: {"width":"380px"},
                      onChange: handleDateRangeChange
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit",
                      loading: loading.value
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(SearchOutlined))
                      ]),
                      default: _withCtx(() => [
                        _cache[17] || (_cache[17] = _createTextVNode(" 查询 ", -1))
                      ]),
                      _: 1,
                      __: [17]
                    }, 8, ["loading"]),
                    _createVNode(_component_a_button, {
                      style: {"margin-left":"8px"},
                      onClick: handleReset
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(ReloadOutlined))
                      ]),
                      default: _withCtx(() => [
                        _cache[18] || (_cache[18] = _createTextVNode(" 重置 ", -1))
                      ]),
                      _: 1,
                      __: [18]
                    }),
                    _createVNode(_component_a_button, {
                      style: {"margin-left":"8px"},
                      type: "primary",
                      loading: exportLoading.value,
                      onClick: handleExport
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(DownloadOutlined))
                      ]),
                      default: _withCtx(() => [
                        _cache[19] || (_cache[19] = _createTextVNode(" 导出 ", -1))
                      ]),
                      _: 1,
                      __: [19]
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_a_tabs, {
              "active-key": activeReportTab.value,
              "onUpdate:activeKey": _cache[13] || (_cache[13] = ($event: any) => ((activeReportTab).value = $event)),
              "destroy-inactive-tab-pane": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "detail",
                  tab: "订单明细"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_spin, { spinning: detailSummaryLoading.value }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _cache[25] || (_cache[25] = _createElementVNode("span", null, "查询结果汇总：", -1)),
                          _createElementVNode("span", null, [
                            _cache[20] || (_cache[20] = _createTextVNode("订单 ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(detailSummary.value.totalOrderCount), 1)
                          ]),
                          _createVNode(_component_a_divider, { type: "vertical" }),
                          _createElementVNode("span", null, [
                            _cache[21] || (_cache[21] = _createTextVNode("取消订单 ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(detailSummary.value.cancelOrderCount), 1)
                          ]),
                          _createVNode(_component_a_divider, { type: "vertical" }),
                          _createElementVNode("span", null, [
                            _cache[22] || (_cache[22] = _createTextVNode("菜品 ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(detailSummary.value.totalFoodQuantity), 1)
                          ]),
                          _createVNode(_component_a_divider, { type: "vertical" }),
                          _createElementVNode("span", null, [
                            _cache[23] || (_cache[23] = _createTextVNode("取消菜品 ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(detailSummary.value.cancelFoodQuantity), 1)
                          ]),
                          _createVNode(_component_a_divider, { type: "vertical" }),
                          _createElementVNode("span", null, [
                            _cache[24] || (_cache[24] = _createTextVNode("金额 ", -1)),
                            _createElementVNode("strong", null, "¥" + _toDisplayString(detailSummary.value.totalAmount.toFixed(2)), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["spinning"]),
                    _createVNode(_component_a_table, {
                      columns: columns,
                      "data-source": tableData.value,
                      loading: loading.value,
                      pagination: false,
                      "row-key": (_r, i) => i,
                      scroll: { x: 2360 }
                    }, {
                      bodyCell: _withCtx(({ column, record }) => [
                        (column.key === 'completeTime' || column.key === 'createTime')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(formatDateTime(record[column.key])), 1))
                          : (column.key === 'price' || column.key === 'amount')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "¥" + _toDisplayString((record[column.key] ?? 0).toFixed(2)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(record[column.key] ?? '-'), 1))
                      ]),
                      _: 1
                    }, 8, ["data-source", "loading", "row-key"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_pagination, {
                        current: queryParams.pageNum,
                        "onUpdate:current": _cache[9] || (_cache[9] = ($event: any) => ((queryParams.pageNum) = $event)),
                        "page-size": queryParams.pageSize,
                        "onUpdate:pageSize": _cache[10] || (_cache[10] = ($event: any) => ((queryParams.pageSize) = $event)),
                        total: total.value,
                        "show-total": (t) => `共 ${t} 条`,
                        "show-size-changer": true,
                        "page-size-options": ['10', '20', '50', '100'],
                        onChange: handlePageChange,
                        onShowSizeChange: handlePageSizeChange
                      }, null, 8, ["current", "page-size", "total", "show-total"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "dashboard",
                  tab: "运营图表"
                }, {
                  default: _withCtx(() => [
                    (dashboardTruncated.value)
                      ? (_openBlock(), _createBlock(_component_a_alert, {
                          key: 0,
                          class: "data-limit-alert",
                          type: "warning",
                          "show-icon": "",
                          message: "查询结果超过 10,000 条，图表仅基于前 10,000 条明细汇总，数据可能不准确，请缩小查询范围"
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_spin, {
                      spinning: dashboardLoading.value,
                      tip: "正在汇总运营数据..."
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("section", _hoisted_8, [
                          (dashboardError.value)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 0,
                                class: "dashboard-error",
                                type: "error",
                                "show-icon": "",
                                message: dashboardError.value
                              }, null, 8, ["message"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiCards.value, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.label,
                                class: "kpi-card"
                              }, [
                                _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1),
                                _createElementVNode("strong", _hoisted_11, _toDisplayString(item.value), 1),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(item.note), 1)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", null, [
                                  _cache[26] || (_cache[26] = _createElementVNode("h3", null, "经营趋势", -1)),
                                  _createElementVNode("p", null, _toDisplayString(trendDescription.value), 1)
                                ]),
                                _createVNode(_component_a_radio_group, {
                                  value: trendGranularity.value,
                                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((trendGranularity).value = $event)),
                                  "button-style": "solid",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio_button, { value: "day" }, {
                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                        _createTextVNode("按天", -1)
                                      ])),
                                      _: 1,
                                      __: [27]
                                    }),
                                    _createVNode(_component_a_radio_button, { value: "hour" }, {
                                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                                        _createTextVNode("按小时", -1)
                                      ])),
                                      _: 1,
                                      __: [28]
                                    }),
                                    _createVNode(_component_a_radio_button, { value: "period" }, {
                                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                                        _createTextVNode("分时段", -1)
                                      ])),
                                      _: 1,
                                      __: [29]
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              (hasTrendData.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createVNode(BaseChart, {
                                      option: trendChartOption.value,
                                      width: trendChartWidth.value,
                                      height: trendChartHeight.value
                                    }, null, 8, ["option", "width", "height"])
                                  ]))
                                : (_openBlock(), _createBlock(_component_a_empty, {
                                    key: 1,
                                    description: "当前条件下暂无趋势数据"
                                  }))
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("h3", null, _toDisplayString(rankingTitle.value), 1),
                                  _createElementVNode("p", null, _toDisplayString(rankingDescription.value), 1)
                                ]),
                                _createVNode(_component_a_radio_group, {
                                  value: rankingMetric.value,
                                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((rankingMetric).value = $event)),
                                  "button-style": "solid",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio_button, { value: "quantity" }, {
                                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                                        _createTextVNode("销量", -1)
                                      ])),
                                      _: 1,
                                      __: [30]
                                    }),
                                    _createVNode(_component_a_radio_button, { value: "netAmount" }, {
                                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                                        _createTextVNode("金额", -1)
                                      ])),
                                      _: 1,
                                      __: [31]
                                    }),
                                    _createVNode(_component_a_radio_button, { value: "lowQuantity" }, {
                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode("销量倒排", -1)
                                      ])),
                                      _: 1,
                                      __: [32]
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              (rankedFoods.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(BaseChart, {
                                      option: foodRankingChartOption.value,
                                      height: rankingChartHeight.value,
                                      width: "max(100%, 760px)"
                                    }, null, 8, ["option", "height"])
                                  ]))
                                : (_openBlock(), _createBlock(_component_a_empty, {
                                    key: 1,
                                    description: "当前条件下暂无菜品排行"
                                  }))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", null, [
                                  _cache[33] || (_cache[33] = _createElementVNode("h3", null, "订单取消占比", -1)),
                                  _createElementVNode("p", null, " 共 " + _toDisplayString(dashboardData.value.cancellation.totalOrderCount) + " 单，取消及部分取消 " + _toDisplayString(dashboardData.value.cancellation.cancelledOrderCount) + " 单 ", 1)
                                ])
                              ]),
                              (dashboardData.value.cancellation.composition.length)
                                ? (_openBlock(), _createBlock(BaseChart, {
                                    key: 0,
                                    option: cancellationChartOption.value
                                  }, null, 8, ["option"]))
                                : (_openBlock(), _createBlock(_component_a_empty, {
                                    key: 1,
                                    description: "暂无订单数据"
                                  }))
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "chart-heading" }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("h3", null, "支付方式金额占比"),
                                  _createElementVNode("p", null, "按支付方式汇总金额，客单价为该方式金额除以订单数")
                                ])
                              ], -1)),
                              (dashboardData.value.paymentComposition.length)
                                ? (_openBlock(), _createBlock(BaseChart, {
                                    key: 0,
                                    option: paymentChartOption.value
                                  }, null, 8, ["option"]))
                                : (_openBlock(), _createBlock(_component_a_empty, {
                                    key: 1,
                                    description: "暂无支付方式数据"
                                  }))
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "chart-heading" }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("h3", null, "菜品分类销量占比"),
                                  _createElementVNode("p", null, "按明细数量原值汇总，未匹配档案的菜品计入“未分类”")
                                ])
                              ], -1)),
                              (!queryParams.data.shopId)
                                ? (_openBlock(), _createBlock(_component_a_empty, {
                                    key: 0,
                                    description: "请选择餐厅后查看菜品分类占比"
                                  }))
                                : (foodCategoryComposition.value.length)
                                  ? (_openBlock(), _createBlock(BaseChart, {
                                      key: 1,
                                      option: foodCategoryChartOption.value
                                    }, null, 8, ["option"]))
                                  : (_openBlock(), _createBlock(_component_a_empty, {
                                      key: 2,
                                      description: "暂无菜品分类销量数据"
                                    }))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "chart-heading" }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("h3", null, "当前库存概览"),
                                _createElementVNode("p", null, "库存为实时快照，不受订单日期及状态条件影响")
                              ])
                            ], -1)),
                            (!queryParams.data.shopId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createVNode(_component_a_empty, { description: "请选择餐厅后查看当前库存" })
                                ]))
                              : (_openBlock(), _createBlock(_component_a_spin, {
                                  key: 1,
                                  spinning: inventoryLoading.value,
                                  tip: "正在加载库存..."
                                }, {
                                  default: _withCtx(() => [
                                    (inventoryError.value)
                                      ? (_openBlock(), _createBlock(_component_a_alert, {
                                          key: 0,
                                          type: "error",
                                          "show-icon": "",
                                          message: inventoryError.value
                                        }, null, 8, ["message"]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("div", null, [
                                              _cache[36] || (_cache[36] = _createElementVNode("span", null, "库存总量", -1)),
                                              _createElementVNode("strong", null, _toDisplayString(inventorySummary.value.totalStock), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[37] || (_cache[37] = _createElementVNode("span", null, "缺货菜品", -1)),
                                              _createElementVNode("strong", null, _toDisplayString(inventorySummary.value.outOfStock), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[38] || (_cache[38] = _createElementVNode("span", null, "低库存菜品", -1)),
                                              _createElementVNode("strong", null, _toDisplayString(inventorySummary.value.lowStock), 1)
                                            ])
                                          ]),
                                          (lowStockFoods.value.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                _createVNode(BaseChart, {
                                                  option: inventoryChartOption.value,
                                                  height: inventoryChartHeight.value,
                                                  width: "max(100%, 760px)"
                                                }, null, 8, ["option", "height"])
                                              ]))
                                            : (_openBlock(), _createBlock(_component_a_empty, {
                                                key: 1,
                                                description: "当前餐厅暂无正常菜品库存数据"
                                              }))
                                        ], 64))
                                  ]),
                                  _: 1
                                }, 8, ["spinning"]))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["spinning"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["active-key"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale"])
  ]))
}
}

})